import React, { useMemo } from 'react';

import { useIsDesktop } from 'app/utils/useWindowType';
import { useI18nContext } from 'app/store/сontext/I18nContext';
import mushroom from 'app/assets/mushroom.png';

const getAdvantages = (threshold: string) => [
    'redCard_terms_insuranceBlock_item1',
    'redCard_terms_insuranceBlock_item2',
    ['redCard_terms_insuranceBlock_item3_android', threshold],
];

export const InsuranceDetails = ({ threshold }: { threshold: string }) => {
    const [isDesktop] = useIsDesktop();
    const { t } = useI18nContext();

    const advantages = useMemo(
        () => getAdvantages(threshold).map(t),
        [threshold],
    );

    return (
        <div className="insuranceDetails">
            <ul className="insuranceAdvantages">
                {advantages.map((item) => (
                    <li className="advantage" key={item}>
                        {item}
                    </li>
                ))}
            </ul>
            {isDesktop && (
                <img className="insuranceImage" src={mushroom} alt={' '} />
            )}
        </div>
    );
};
